import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import { DataTable, CampusSingleDrawerSatisfaction } from "../../../../";
import { Grid, Typography, makeStyles, Chip } from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
var useStyles = makeStyles(function (theme) {
  return {
    containerMetrics: {
      display: "flex"
    },
    containerMetric: {
      margin: "12px",
      display: "flex",
      flexDirection: "column"
    },
    flexAlignCenter: {
      width: "100%",
      display: "flex",
      justifyContent: "center"
    },
    p20: {
      padding: "20px"
    },
    my12: {
      margin: "12px 0"
    },
    mt12: {
      marginTop: "12px"
    },
    title: {
      fontWeight: "600"
    },
    chip: {
      border: "2px solid " + theme.palette.text.primary,
      borderRadius: "4px",
      minWidth: "100px",
      background: "transparent",
      fontSize: "20px"
    }
  };
});

var CampusSingleTabSatisfaction = function CampusSingleTabSatisfaction(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      openDrawer = _useState2[0],
      setOpenDrawer = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      satisfactionSelected = _useState4[0],
      setSatisfactionSelected = _useState4[1];

  var classes = useStyles();

  var toggleDrawer = function toggleDrawer() {
    setOpenDrawer(!openDrawer);
  };

  var handleSelectSatisfaction = function handleSelectSatisfaction(_id) {
    if (_id) {
      var satisfaction = props.satisfaction.satisfactions.find(function (satisfaction) {
        return satisfaction._id === _id;
      });
      setSatisfactionSelected(satisfaction);
      toggleDrawer();
    } else {
      setSatisfactionSelected(null);
      toggleDrawer();
    }
  };

  var auxTranslation = props.translation;

  if (auxTranslation && auxTranslation.datatables && auxTranslation.datatables.satisfactions) {
    !auxTranslation.datatables.satisfactions.columns.find(function (column) {
      return column.name === "options";
    }) ? auxTranslation.datatables.satisfactions.columns.push({
      label: "",
      name: "options",
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        empty: true,
        label: false,
        customBodyRender: function customBodyRender(value, tableMeta, updateValue) {
          return /*#__PURE__*/React.createElement(VisibilityIcon, {
            onClick: function onClick() {
              return handleSelectSatisfaction(tableMeta.rowData[0]);
            }
          });
        }
      }
    }) : auxTranslation.datatables.satisfactions.columns[auxTranslation.datatables.satisfactions.columns.length - 1] = {
      label: "",
      name: "options",
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        empty: true,
        label: false,
        customBodyRender: function customBodyRender(value, tableMeta, updateValue) {
          return /*#__PURE__*/React.createElement(VisibilityIcon, {
            onClick: function onClick() {
              return handleSelectSatisfaction(tableMeta.rowData[0]);
            }
          });
        }
      }
    };
  }

  return /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6,
    className: classes.p20,
    style: {
      border: "1px solid white",
      borderRadius: "4px"
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.title
  }, props.translation ? props.translation.texts ? props.translation.texts.text_1 || "This is what the users of your campus think" : "This is what the users of your campus think" : "This is what the users of your campus think"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.mt12
  }, props.translation ? props.translation.texts ? props.translation.texts.text_2_0 || "The " : "The " : "The ", /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: "24px"
    }
  }, props.satisfaction ? props.satisfaction.recommends ? props.satisfaction.recommends.repeat || "0" : "0" : "0", "%"), props.translation ? props.translation.texts ? props.translation.texts.text_2_1 || " would repeat the experience in the camp" : " would repeat the experience in the camp" : " would repeat the experience in the camp"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: [classes.title, classes.mt12].join(" ")
  }, props.translation ? props.translation.texts ? props.translation.texts.text_3 || "We have also asked them if they would recommend ..." : "We have also asked them if they would recommend ..." : "We have also asked them if they would recommend ..."), /*#__PURE__*/React.createElement("div", {
    className: [classes.containerMetrics, classes.my12].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.containerMetric
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    className: classes.title
  }, props.translation ? props.translation.chips ? props.translation.chips.sportmadness || "Sportmadness" : "Sportmadness" : "Sportmadness"), /*#__PURE__*/React.createElement(Chip, {
    className: classes.chip,
    label: "".concat(props.satisfaction ? props.satisfaction.recommends ? props.satisfaction.recommends.sportmadness || "0" : "0" : "0", "/5")
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.containerMetric
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    className: classes.title
  }, " ", props.translation ? props.translation.chips ? props.translation.chips.campus || "Campus" : "Campus" : "Campus"), /*#__PURE__*/React.createElement(Chip, {
    className: classes.chip,
    label: "".concat(props.satisfaction ? props.satisfaction.recommends ? props.satisfaction.recommends.service || "0" : "0" : "0", "/5")
  }))), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.title
  }, props.translation ? props.translation.texts ? props.translation.texts.text_4 || "This is how they valued your value proposition" : "This is how they valued your value proposition" : "This is how they valued your value proposition"), /*#__PURE__*/React.createElement("div", {
    className: [classes.containerMetrics, classes.my12].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.containerMetric
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    className: classes.title
  }, props.translation ? props.translation.chips ? props.translation.chips.venues || "Venues" : "Venues" : "Venues"), /*#__PURE__*/React.createElement(Chip, {
    className: classes.chip,
    label: "".concat(props.satisfaction ? props.satisfaction.metrics ? props.satisfaction.metrics.find(function (metric) {
      return metric.name === "venues";
    }) ? props.satisfaction.metrics.find(function (metric) {
      return metric.name === "venues";
    }).rating || "0" : "0" : "0" : "0", "/5")
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.containerMetric
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    className: classes.title
  }, props.translation ? props.translation.chips ? props.translation.chips.activities || "Activities" : "Activities" : "Activities"), /*#__PURE__*/React.createElement(Chip, {
    className: classes.chip,
    label: "".concat(props.satisfaction ? props.satisfaction.metrics ? props.satisfaction.metrics.find(function (metric) {
      return metric.name === "activities";
    }) ? props.satisfaction.metrics.find(function (metric) {
      return metric.name === "activities";
    }).rating || "0" : "0" : "0" : "0", "/5")
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.containerMetric
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    className: classes.title
  }, props.translation ? props.translation.chips ? props.translation.chips.trainers || "Staff" : "Staff" : "Staff"), /*#__PURE__*/React.createElement(Chip, {
    className: classes.chip,
    label: "".concat(props.satisfaction ? props.satisfaction.metrics ? props.satisfaction.metrics.find(function (metric) {
      return metric.name === "trainers";
    }) ? props.satisfaction.metrics.find(function (metric) {
      return metric.name === "trainers";
    }).rating || "0" : "0" : "0" : "0", "/5")
  }))), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.title
  }, props.translation ? props.translation.texts ? props.translation.texts.text_5 || "What assessment have you given to the app as a communication tool?" : "What assessment have you given to the app as a communication tool?" : "What assessment have you given to the app as a communication tool?"), /*#__PURE__*/React.createElement("div", {
    className: [classes.flexAlignCenter, classes.my12].join(" ")
  }, /*#__PURE__*/React.createElement(Chip, {
    className: classes.chip,
    label: "".concat(props.satisfaction ? props.satisfaction.metrics ? props.satisfaction.metrics.find(function (metric) {
      return metric.name === "app";
    }) ? props.satisfaction.metrics.find(function (metric) {
      return metric.name === "app";
    }).rating || "0" : "0" : "0" : "0", "/5")
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6,
    className: classes.p20
  }, /*#__PURE__*/React.createElement(DataTable, {
    data: props.satisfaction ? props.satisfaction.satisfactions || [] : [],
    translation: auxTranslation ? auxTranslation.datatables ? auxTranslation.datatables.satisfactions || null : null : null
  })), /*#__PURE__*/React.createElement(CampusSingleDrawerSatisfaction, {
    data: satisfactionSelected,
    open: openDrawer,
    toggleDrawer: toggleDrawer,
    translation: props.translation ? props.translation.drawers ? props.translation.drawers.satisfaction : null : null
  }));
};

export { CampusSingleTabSatisfaction };